// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cZv1M39PpVQDdFHk1llG{flex-direction:column;align-items:center;display:flex}.RYOHNngxjgQtaobPZcYW{border-radius:16px;align-items:flex-end;min-height:276px;margin-bottom:40px;display:flex;overflow:hidden}.RYOHNngxjgQtaobPZcYW img{width:628px;height:auto;display:block}.SxAhd9kjFc4RXSyeTxR_{text-align:center;margin-top:4px}.aGHxYtzA4a0j_R4NWXPU{text-align:center}.aGHxYtzA4a0j_R4NWXPU a{color:var(--content-primary-tertiary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `cZv1M39PpVQDdFHk1llG`,
	"previewImageContainer": `RYOHNngxjgQtaobPZcYW`,
	"subTitleText": `SxAhd9kjFc4RXSyeTxR_`,
	"terms": `aGHxYtzA4a0j_R4NWXPU`
};
export default ___CSS_LOADER_EXPORT___;
